import type { Message } from "@nexus/types"
import { createAsyncThunk } from "@reduxjs/toolkit"

import { getEmbeddedChatMessages } from "@/common/services/chat"

interface LoadEmbedMessagesParams {
  chatId: string
  deploymentId: string
  sessionId: string
  agentId: string
}

/**
 * Load embed chat messages
 */
export const loadEmbedMessages = createAsyncThunk(
  "embedChat/loadMessages",
  async ({ chatId, deploymentId, sessionId, agentId }: LoadEmbedMessagesParams) => {
    const response = await getEmbeddedChatMessages({
      chatRoomId: chatId,
      agentId,
      sessionId,
      deploymentId,
      limit: "20",
      sortBy: "createdAt",
      order: "desc" // Get newest messages
    })

    // Reverse to display in chronological order
    const messages = (response.messages as Message[]).reverse()

    return {
      chatId,
      messages
    }
  }
)
